import { LINK_TO_ROUTE } from "constants/common";
import Environment from "services/environment";

const env = Environment.getEnv();

const filterConfig = (config) =>
  config.filter((menuItem) => {
    let { show, subMenu } = menuItem;
    if (show) {
      subMenu = subMenu.filter((subMenuitem) => subMenuitem);
      return true;
    }
    return false;
  });

export const getServiceConfig = ({ isInternalUser, isGuestUser }) => {
  const SERVICE_CONFIG = [
    {
      code: "home",
      name: "Dashboard",
      show: true,
      isExternalLink: false,
      isPartyIdSupported: true,
      url: LINK_TO_ROUTE.DASHBOARD,
      iconClass: "outlined-name",
      pathRegex: ["selfcare/dashboard", "data/dashboard", "airtel-cloud/dashboard", "mobility/dashboard", "nxtra/dashboard", "internet/dashboard", "cyber-security/dashboard"],
      subMenu: [],
    },
    {
      code: "products",
      name: "My Products",
      show: true,
      isExternalLink: false,
      isPartyIdSupported: true,
      iconClass: "outlined-products",
      pathRegex: ["/connections", "/circuits", "/services", "/tenants"],
      subMenu: [],
    },
    {
      code: "billing",
      name: "Billing & Payments",
      show: true,
      isExternalLink: false,
      isPartyIdSupported: true,
      iconClass: "outlined-bills",
      pathRegex: ["/billing"],
      subMenu: [
        {
          code: "payBills",
          name: "Pay Bills",
          show: true,
          isExternalLink: false,
          isPartyIdSupported: true,
          url: LINK_TO_ROUTE.BILL_PAY_AND_DOWNLOAD,
          pathRegex: ["billing/pay-and-download"],
          subMenu: [],
        },
        {
          code: "neftPayment",
          name: "NEFT Payment",
          show: true,
          isExternalLink: false,
          isPartyIdSupported: true,
          url: LINK_TO_ROUTE.NEFT_PAYMENT,
          pathRegex: ["billing/declare"],
          subMenu: [],
        },
        {
          code: "vanPayment",
          name: "VAN/Suspense Payment",
          show: true,
          isExternalLink: false,
          isPartyIdSupported: true,
          url: LINK_TO_ROUTE.VAN_PAYMENT,
          pathRegex: ["billing/allocate"],
          subMenu: [],
        },
        {
          code: "paymentHistory",
          name: "Payment History",
          show: true,
          isExternalLink: false,
          isPartyIdSupported: true,
          url: LINK_TO_ROUTE.PAYMENT_HISTORY,
          pathRegex: ["billing/payment"],
          subMenu: [],
        },
      ],
    },
    {
      code: "serviceRequests",
      name: "Service Requests",
      show: true,
      isExternalLink: false,
      isPartyIdSupported: true,
      iconClass: "outlined-support",
      pathRegex: ["/sr"],
      subMenu: [
        {
          code: "allRequests",
          name: "All Requests",
          show: true,
          isExternalLink: false,
          isPartyIdSupported: true,
          url: LINK_TO_ROUTE.SR_DASHBOARD,
          pathRegex: ["sr/dashboard"],
          subMenu: [],
        },
        {
          code: "raiseSR",
          name: "Raise Service Request",
          show: true,
          isExternalLink: false,
          isPartyIdSupported: true,
          url: LINK_TO_ROUTE.SR_RAISE,
          pathRegex: ["sr/raise"],
          subMenu: [],
        },
        {
          code: "searchRequest",
          name: "Search Request",
          show: true,
          isExternalLink: false,
          isPartyIdSupported: true,
          url: LINK_TO_ROUTE.SR_TRACK,
          pathRegex: ["sr/track"],
          subMenu: [],
        },
      ],
    },
    {
      code: "trackOrders",
      name: "My Orders",
      show: true,
      isExternalLink: false,
      isPartyIdSupported: true,
      url: LINK_TO_ROUTE.TRACK_ORDER,
      iconClass: "outlined-cart",
      pathRegex: ["/track-orders"],
      subMenu: [],
      isInBetaPhase: false,
    },
    {
      code: "myUtitilities",
      name: "My Utilities",
      show: isInternalUser,
      isExternalLink: true,
      isPartyIdSupported: true,
      iconClass: "outlined-utility",
      pathRegex: ["/b2b/acquisition"],
      subMenu: [
        {
          code: "feasibilityTool",
          name: "Feasibility Tool",
          show: true,
          isExternalLink: true,
          isPartyIdSupported: false,
          url: env.bulkFeasibilityBasePageUrl,
          pathRegex: ["/bulk-feasibility"],
          subMenu: [],
        },
      ],
    },
    {
      code: "help",
      name: "Get Help",
      show: true,
      isExternalLink: false,
      isPartyIdSupported: false,
      url: LINK_TO_ROUTE.HELP,
      iconClass: "outlined-learn",
      pathRegex: ["/help"],
      subMenu: [],
    },
  ];

  const GUEST_SERVICE_CONFIG = [
    {
      code: "home",
      name: "Dashboard",
      show: true,
      isExternalLink: false,
      isPartyIdSupported: true,
      url: "/selfcare/guest/dashboard",
      iconClass: "outlined-name",
      pathRegex: ["selfcare/dashboard", "guest/dashboard"],
      subMenu: [],
    },
    {
      code: "product",
      name: "My Products",
      show: true,
      isExternalLink: false,
      isPartyIdSupported: true,
      url: `/selfcare/guest/dashboard#noProduct`,
      iconClass: "outlined-products",
      pathRegex: [],
      subMenu: [],
    },
    {
      code: "billing",
      name: "Billing & Payments",
      show: true,
      isExternalLink: false,
      isPartyIdSupported: true,
      url: `/selfcare/guest/dashboard#noProduct`,
      iconClass: "outlined-bills",
      pathRegex: [],
      subMenu: [],
    },
    {
      code: "serviceRequests",
      name: "My Service Requests",
      show: true,
      isExternalLink: false,
      isPartyIdSupported: true,
      url: `/selfcare/guest/dashboard#noProduct`,
      iconClass: "outlined-support",
      pathRegex: [],
      subMenu: [],
    },
    {
      code: "trackOrders",
      name: "My Orders",
      show: true,
      isExternalLink: false,
      isPartyIdSupported: true,
      url: "/selfcare/guest/track-orders/dashboard",
      iconClass: "outlined-cart",
      pathRegex: ["/track-orders"],
      isInBetaPhase: false,
      subMenu: [],
    },
    {
      code: "help",
      name: "Visit Help Centre",
      show: true,
      isExternalLink: false,
      isPartyIdSupported: false,
      url: "/selfcare/help/",
      iconClass: "outlined-learn",
      pathRegex: ["/help"],
      subMenu: [],
    },
  ];

  if (isGuestUser) {
    return filterConfig(GUEST_SERVICE_CONFIG);
  }
  return filterConfig(SERVICE_CONFIG);
};
